// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global  */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        __slick: function() {

            const employees = wntrTheme.body.find('.employees__wrapper');
            const gallery = wntrTheme.body.find('.image-banner--media-gallery');
            const imageWrapper = wntrTheme.body.find('.image-banner__media-wrap');
            let employeeSlickSettings = undefined;

            if(employees.length) {
                employeeSlickSettings = {
                    dots: true,
                    arrows: false,
                    infinite: false,
                    speed: 300,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                };
                if(window.innerWidth < 1024) {
                    $(employees).slick(employeeSlickSettings);
                }
            }

            if(gallery.length) {
                $(imageWrapper).slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    speed: 1200
                });
            }

            $(window).on('resize', function() {
                if(window.innerWidth >= 1024 && employees.hasClass('slick-initialized')) {
                    $(employees).slick('unslick');
                } else if(window.innerWidth < 1024 && !employees.hasClass('slick-initialized')) {
                    $(employees).slick(employeeSlickSettings);
                }
            });

        },

        __initalize: function() {
            if($(this).scrollTop() >= 50 && window.innerWidth >= 1024) {
                wntrTheme.body.addClass('started-scroll');
            }
        },

        // __appendAnchorToCard: function() {
        //     const links = wntrTheme.body.find('.service-card__text');
        //     if(links.length) {
        //         links.children('p').append("<a href=" + links.data('permalink') + " class='service-card__read-more'>Läs mer</a>");
        //     }
        // },

        /**
         * Initialize video banner
         */
        __initVideoBanner: function() {
            const video = wntrTheme.body.find('.image-banner--media-video');
            if(video.length) {
                $('.video-background').find('video').attr('playsinline', true);
                $('.video-background').find('video').get(0).play();
            }
        },

        __onScrollDown: function() {
            $(window).scroll(function() {
                if($(this).scrollTop() >= 50 && window.innerWidth >= 1024) {
                    wntrTheme.body.addClass('started-scroll');
                } else if(window.innerWidth >= 1024) {
                    wntrTheme.body.removeClass('started-scroll');
                }
            });
        },

        /**
         * Toggle header
         */
        __toggleHeader: () => {
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');
            const header = wntrTheme.body.find('.header--mobile');
            const main = wntrTheme.body.find('main');

            toggleHeaderButton.on('click', function() {
                if(header.hasClass('mobile-menu-active')) {
                    wntrTheme.body.removeClass('fixed');
                    header.removeClass('mobile-menu-active');
                    main.removeClass('mobile-menu-active');
                    $(this).removeClass('is-active');
                } else {
                    header.addClass('mobile-menu-active');
                    main.addClass('mobile-menu-active');
                    wntrTheme.body.addClass('fixed');
                    $(this).addClass('is-active');
                }
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && header.hasClass('mobile-menu-active')) {
                    header.removeClass('mobile-menu-active');
                    main.removeClass('mobile-menu-active');
                    wntrTheme.body.removeClass('fixed');
                    wntrTheme.body.find('.header__toggle-menu').removeClass('is-active');
                }
            });
        },

        /**
         * Init equalize
         */
        __equalHeight: function() {
            const employee = wntrTheme.body.find('.employee__content');
            if(employee.length) {
                employee.matchHeight();
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);